import { DocumentsFilter } from './documents-page.types';

export const DEBOUNCE_TIME = 1000;

export const DEFAULT_FILTER: DocumentsFilter = {
  kkmId: null,
  documentType: [],
};
export const DOCUMENTS_PAGE_SIZE = 10;
